module.exports = __webpack_public_path__ + "media/images/icons/icon_2_user-a0f2c3d0311ae31db66d939b39982a0b.svg";